//=====================================================
//　システムエラー情報
//=====================================================
import { useState } from 'react';
import * as H from 'history';
import { useEffect } from 'react';

//システムエラー情報IF
export interface IFUseSystemErr { 
    errmess: string,
    setErrmess: React.Dispatch<React.SetStateAction<string>>,
    setHistory: React.Dispatch<React.SetStateAction<H.History<unknown> | undefined>>,
}

//-----------------------------------------------------
//　システムエラー情報管理
//-----------------------------------------------------
export function useSystemErr():IFUseSystemErr{
    
    const [errmess, setErrmess] = useState("");
    const [history, setHistory] = useState<H.History>();

    useEffect(function(){
        if (errmess && history){
            history.push("/error");
        }
    }, [errmess, history]);

    return {errmess, setErrmess, setHistory};

}